import { LayoutModule } from '../../../../layout/modules';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useAlertsDetail } from './hook';
import { AlertsProcess } from './process';
import { AlertsSection } from './execution';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    ALERTS_DETAIL,
    ALERTS_EDIT,
    ALERTS,
} from '../../../../../routes/paths';

import { AlertHistorical } from '../historical';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    isOnlyViewProfile,
    isSwitchAgent,
} from '../../../../../shared/types/profiles';

export const AlertsDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { alert, loading, alertHistorical } = useAlertsDetail();

    const [showHistorical, setShowHistorical] = useState(false);

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons = alert && alert?.id ? true : false;

    return (
        <>
            <LayoutModule
                title="Detalle regla alertas"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={alert?.id || ''}
                        buttonSearch={{
                            show: true,
                            route: ALERTS,
                        }}
                        buttonUpdate={{
                            show:
                                !isOnlyViewProfile(type) &&
                                !isSwitchAgent(type),
                            route: ALERTS_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: ALERTS_DETAIL,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <AlertHistorical
                            historical={alertHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Proceso"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PeopleAltIcon sx={{ color: 'primary.main' }} />}
                >
                    <AlertsProcess alert={alert} loading={loading} />
                </LayoutModule>
            </LayoutModule>
            <AlertsSection
                alertSection={alert?.alertSection}
                loading={loading}
            />
        </>
    );
};
